export const selectStyles = {
  '.MuiSelect-select': { paddingTop: 0, paddingBottom: 0 },
  '&::after': { content: 'none' },
  '&::before': { content: 'none' },
}
